import { render } from "./linksView.vue?vue&type=template&id=6f6c902c&scoped=true"
import script from "./linksView.vue?vue&type=script&lang=js"
export * from "./linksView.vue?vue&type=script&lang=js"

import "./linksView.vue?vue&type=style&index=0&id=6f6c902c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f6c902c"]])

export default __exports__